import request from '@/utils/request'

export function Login(data) {
  return request({
    url: '/sys/appLogin',
		method:'post',
		data
  })
}